<template>
  <modal name="success">
    <h1 class="text-xl font-bold mb-8 light-blue">Enrolled! Text Message Sent.</h1>
    <img class="m-auto mb-8 w-52" src="../../assets/images/airballoon.png">
    <p class="mb-4">Text message sent - includes link to download the Connections app and temporary password.</p>
    <p class="mb-4 text-xl">Temporary Password: <span class="light-blue">{{patient.temp_pass}}</span></p>
    <!-- Email -->
    <div class="mb-6" v-if="patient.email">
      <div class="text">Email with download link and new temporary password has also been sent to {{patient.email}}</div>
    </div>
    <div class="mb-6" v-if="!patient.email">
      <div class="text">You can also receive this information through email by submitting one below:</div>
      <div class="flex justify-center items-center mt-2">
        <input type="email" class="form-control w-3/5" placeholder="Email Address" v-model="email" />
        <button class="ml-2 w-24 send" @click="sendEmail">Send</button>
      </div>
    </div>
    <p class="mb-8">Quick tip: Your text message might not appear in your main messages. If you're an iPhone user, check for a message in the 'Unknown Sender' text list,
      and if you're an Android user, peek in your spam folder. Look for anything mentioning 'Connections app'. It should be in your inbox within a minute.
    </p>
    <p class="mb-8">if you do not see it, please email support: <a class="light-blue" href="mailto:support@chess.health">support@chess.health</a></p>
    <button class="w-24" @click="closeModal">Close</button>
    <LoadingUI msg="Sending email..." v-if="loading" />
  </modal>
</template>

<script>
import { sendOnboardEmail } from '../../services/ssu-service'
import LoadingUI from '../LoadingUI.vue'

export default {
  name: 'SuccessModal',
  components: { // imported components
    LoadingUI
  },
  props: { // props passed into component
    patient: Object
  },
  data() { // component props
    return {
      email: '',
      loading: false
    }
  },
  created() { /* Called synchronously after the instance is created */ },
  mounted() { /* Called after the instance has been mounted */ },
  methods: { // component functions
    sendEmail() {
      const toastOptions = {
        title: "Error",
        msg: "There was a problem submitting the form.<br>Please contact support@connectionsapp.com for assistance.",
        type: "error",
        position: "toast-bottom-right",
        style: { "width": "430px" }
      };
      if (this.email) {
        // submit email request
        this.loading = true;
        sendOnboardEmail(this.patient, this.email).then(res => {
          if (res.success) {
            this.loading = false;
            this.$toastr.Add({
              title: "",
              msg: `Email with download link and new temporary password has been sent to ${this.email}`,
              type: "success",
              position: "toast-bottom-right",
              style: { "width": "430px" }
            });
            this.email = '';
          } else {
            this.loading = false;
            this.$toastr.Add(toastOptions);
          }
        }).catch(err => {
          console.error(err);
          this.loading = false;
          this.$toastr.Add(toastOptions);
        });
      } else {
        this.$toastr.Add({
          title: "",
          msg: 'Please provide an email address',
          type: "error",
          position: "toast-bottom-right",
          style: { "width": "auto", "min-width": "300px" }
        });
      }
    },
    closeModal() {
      this.$modal.hide('success');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  button {
    height: 40px;
    font-size: 14px;
    color: #fff;
    border: none;
    padding: 6px 12px;
    border-radius: 40px;
    background: #319af1;
  }
    button.send {
      border-radius: 4px;
    }
  .light-blue {
    color: #319af1;
  }
  input {
    font-size: 14px;
    font-weight: 400;
    color: #333;
    height: 40px;
    border-radius: 4px;
    padding: 6px 12px;
    line-height: 1.42857143;
    border: 1px solid #ccc;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  }
    input:focus {
      border-color: #66afe9;
      outline: 0;
      -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
      box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
    }
</style>

<!-- Not "scoped" to style modal -->
<style>
  .vm--container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .vm--overlay {
    background: rgba(8, 17, 53, 0.38) !important;
  }
  .vm--modal {
    text-align: center;
    border-radius: 4px !important;
    background: #ffffff;
    padding: 20px;
    height: auto !important;
    width: auto !important;
    max-width: 600px;
    top: auto !important;
    left: auto !important;
  }
</style>
